import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CiCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/CiCircleTwoTone";
import AntdIcon from '../components/AntdIcon';
var CiCircleTwoTone = function CiCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: CiCircleTwoToneSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(CiCircleTwoTone);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'CiCircleTwoTone';
}
export default RefIcon;